'use client';

import { Details } from '@velocity-exchange/icons';
import React from 'react';
import { cj } from 'src/utils/classNames';
import useDriftClientIsReady from 'src/hooks/useDriftClientIsReady';
import { useDrawersStore } from 'src/stores/useDrawersStore';
import { UIMarket } from '@velocity-exchange/common';
import { MARKET_STATS_BAR_CELL_LABEL_CLASSNAME } from 'src/components/MarketStatsBar/consts';
import TextButton from 'src/components/primitives/TextButton/TextButton';

const _ViewDetailsForMarketButton = ({ market }: { market: UIMarket }) => {
	const driftClientIsReady = useDriftClientIsReady();
	const setDrawerStore = useDrawersStore((s) => s.set);

	const showMarketDetailsPanel = () => {
		if (driftClientIsReady) {
			setDrawerStore((s) => {
				s.marketDetails.uiMarket = market;
				s.marketDetails.goToPnl = false;
				s.marketDetails.show = true;
			});
		}
	};

	return (
		<div className="flex flex-col items-start gap-y-xs px-sm select-none">
			<span
				className={cj(
					'text-text-secondary',
					MARKET_STATS_BAR_CELL_LABEL_CLASSNAME
				)}
			>
				Market Details
			</span>

			<TextButton rightIcon={Details} onClick={showMarketDetailsPanel}>
				View
			</TextButton>
		</div>
	);
};

export const ViewDetailsForMarketButton = React.memo(
	_ViewDetailsForMarketButton
);
